export default "__VITE_ASSET__BDh0W2Aa__"